module.exports = __webpack_public_path__ + "static/media/arrow-right.dc372a07.svg";